const DownloadIcon = ({ height = "22", width = "22" }) => {
  return (<svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"

  >
    <g clip-path="url(#clip0_940_4879)">
      <path d="M11.9167 9.16667H16.5L11 14.6667L5.50004 9.16667H10.0834V2.75H11.9167V9.16667ZM3.66671 17.4167H18.3334V11H20.1667V18.3333C20.1667 18.5764 20.0701 18.8096 19.8982 18.9815C19.7263 19.1534 19.4932 19.25 19.25 19.25H2.75004C2.50693 19.25 2.27377 19.1534 2.10186 18.9815C1.92995 18.8096 1.83337 18.5764 1.83337 18.3333V11H3.66671V17.4167Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_940_4879">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
  )
}
export default DownloadIcon;